import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { GlobalService } from 'src/app/global.service';
import { SellOutDetailsComponent } from '../sell-out-details/sell-out-details.component';

@Component({
  selector: 'app-dealer-sell-out',
  templateUrl: './dealer-sell-out.component.html',
  styleUrls: ['./dealer-sell-out.component.css']
})
export class DealerSellOutComponent {
  
  @ViewChild(SellOutDetailsComponent) 
  private sellOutDetailsComponent!:SellOutDetailsComponent;

  @Input() sellOutData : Array<any> = [];  
  @Input() isLoading : boolean = false;
  @Input() message : String = "";
  @Input() currentTab : String = "";
  isMobile : boolean = false;
  @Output() updateSort = new EventEmitter<Sort>();

  constructor(
    public globalservice : GlobalService
  ){}

  ngOnInit(){
    this.isMobile = this.globalservice.isMobile();
  }

  sortData(sort:Sort){
    this.updateSort.emit(sort);
  }

  onClickRow(details:any){
    this.sellOutDetailsComponent.setSellOutData(details);
  }
  

}
